import { Component, OnInit } from '@angular/core';
import { FirebaseFirestore } from '@angular/fire';
import { DBFirestoreService } from './dbfirestore.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { SwUpdate, SwPush } from '@angular/service-worker';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'Ordini di lavoro';

}
